import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import {
  TCustomSlice,
  TSlice,
  TSliceSelectionMode,
  TSlicesResult,
  TStandardSlice
} from 'types/GlobalSlice'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

const toSlicesResult = (
  slices: TSlice[],
  selectionMode: TSliceSelectionMode
): TSlicesResult => {
  const sorted = [...slices].sort((a, b) => sortAlphabeticalAsc(a.name, b.name))

  return {
    all: sorted,
    disabled: sorted.filter((s) => s.disabled),
    available: sorted.filter((s) => !s.disabled),
    custom: sorted.filter((s): s is TCustomSlice => !s.standard),
    standard: sorted.filter((s): s is TStandardSlice => s.standard),
    selection_mode: selectionMode
  }
}

export const selectSlicesById = (state: ApplicationState) =>
  state.SliceStore.data

export const selectEntitySlicesMapper = createSelector(
  [
    (state: ApplicationState) => state.EntityStore.data,
    (state: ApplicationState) => state.SliceStore.data
  ],
  (entities, slices): { [entityId: string]: TSlicesResult } => {
    const mapper: { [entityId: string]: TSlice[] } = Object.fromEntries(
      Object.keys(entities).map((entityId) => [entityId, []])
    )

    Object.values(slices).forEach((slice) => {
      (mapper[slice.entity_id] ??= []).push(slice)
    })

    return Object.fromEntries(
      Object.entries(mapper).map(([entityId, entitySlices]) => [
        entityId,
        toSlicesResult(
          entitySlices,
          entities[entityId]?.slice_selection ?? 'multi_optional'
        )
      ])
    )
  }
)
